import { fireTrack } from "@swa-ui/analytics";

import { getTripType } from "../utils";
import {
  getAbbreviatedSeatsOption,
  getFlightDetails,
  getSeatMapDetails,
} from "./airSeatsHelperUtils";
import { AIR_SEAT_TYPES } from "./defines/airSeatTypes";

const CONVERTED_SEAT_TYPE = {
  exit: AIR_SEAT_TYPES.EXIT_ROW,
  extraLegRoom: AIR_SEAT_TYPES.EXTRA_LEGROOM,
  preferred: AIR_SEAT_TYPES.PREFERRED,
  standard: AIR_SEAT_TYPES.STANDARD,
};

export const firePassengerSelectionClickAnalytics = (passengerId = 1) => {
  fireTrack("squid", {
    page_description: "button:passenger selection",
    pax_number: `${passengerId}`,
  });
};

export const fireViewSeatClickAnalytics = (
  seats = {},
  flightSegments = [],
  selectedSegment = 0
) => {
  fireTrack("squid", {
    ...getFlightDetails(flightSegments, selectedSegment),
    ...getSeatMapDetails(seats, selectedSegment),
    page_description: "modal:view seatmap",
    segment_number: `${flightSegments[selectedSegment]?.id}`,
    segments: `${flightSegments?.length}`,
  });
};

export const fireSeatSelectionFlyout = (
  seatInfo = {},
  seatMapData = {},
  selectedSegmentFlightDetails = {}
) => {
  fireTrack("squid", {
    airport_codes: `${selectedSegmentFlightDetails?.flightSegment?.origin}:${selectedSegmentFlightDetails?.flightSegment?.destination}`,
    page_description: "flyout:seat selection",
    product: "seat",
    productprice: seatInfo.price || "0.00",
    prodView: "1",
    seatcolumn: seatInfo?.designation?.replace(`${seatInfo.rowNumber}`, ""),
    seatrow: `${seatInfo.rowNumber}`,
    seatsstandalone: seatMapData?.value?.appId ? "0" : "1",
    seattype: getAbbreviatedSeatsOption(seatInfo.characteristics),
    triptype: getTripType(seatMapData?.value?.tripType),
  });
};

export const fireSeatSelectionNextButton = (
  currentSeatInfo = {},
  selectedSegmentFlightDetails = {},
  seatMapData = {},
  selectedSeatTransaction = ""
) => {
  const upgradePriceRaw = currentSeatInfo.upgradePrice;
  const upgradePrice = Number(upgradePriceRaw) === 0 ? "0.00" : upgradePriceRaw || "0.00";

  fireTrack("squid", {
    airport_codes: `${selectedSegmentFlightDetails?.flightSegment?.origin}:${selectedSegmentFlightDetails?.flightSegment?.destination}`,
    page_description: "button:select seat",
    product: "seat",
    productprice: selectedSeatTransaction === "EXCHANGE" ? "0.00" : upgradePrice,
    scAdd: "1",
    seatcolumn: currentSeatInfo?.column,
    seatrow: `${currentSeatInfo.row}`,
    seatsstandalone: seatMapData?.appId ? "0" : "1",
    seattype: getAbbreviatedSeatsOption(CONVERTED_SEAT_TYPE[currentSeatInfo.seatType]),
    triptype: getTripType(seatMapData?.tripType),
  });
};

export const fireSeatTierChangeDialog = (isSeatUpgrade) => {
  const pageDescription = isSeatUpgrade
    ? "seat price difference"
    : "original seat is non-refundable";

  fireTrack("squid", {
    page_description: `modal:${pageDescription}`,
  });
};

export const fireSeatSelectionNextFlightButton = () => {
  fireTrack("squid", {
    page_description: "button:seatselectionnextflight",
  });
};

export const fireSelectSeatmapTab = () => {
  fireTrack("squid", {
    page_description: "tab:seatmapsegment",
  });
};
